// Formatting helpers for SEO engine data. Times are shown in the market's own time zone.
import type { SeoMarket } from "./types";

export const MARKET_TZ: Record<SeoMarket, string> = {
  SE: "Europe/Stockholm",
  NO: "Europe/Oslo",
  FI: "Europe/Helsinki",
  DK: "Europe/Copenhagen",
  DE: "Europe/Berlin",
  ZA: "Africa/Johannesburg",
  FR: "Europe/Paris",
  ES: "Europe/Madrid",
};

export function localParts(iso: string, tz: string): { minutes: number; hhmm: string } {
  const parts = new Intl.DateTimeFormat("da-DK", { timeZone: tz, hour: "2-digit", minute: "2-digit", hourCycle: "h23" })
    .formatToParts(new Date(iso));
  const h = Number(parts.find((p) => p.type === "hour")?.value ?? 0);
  const m = Number(parts.find((p) => p.type === "minute")?.value ?? 0);
  return { minutes: h * 60 + m, hhmm: `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}` };
}

export function fmtDay(isoDate: string): string {
  const d = new Date(`${isoDate}T12:00:00Z`);
  return new Intl.DateTimeFormat("da-DK", { weekday: "short", day: "numeric", month: "short" }).format(d);
}

export function fmtDateTime(iso: string | null | undefined, tz?: string): string {
  if (!iso) return "–";
  return new Intl.DateTimeFormat("da-DK", {
    timeZone: tz, day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
  }).format(new Date(iso));
}

export const MODE_LABEL: Record<string, string> = { dry_run: "Dry-run", live: "Live", off: "Slået fra" };

export const DAY_LABEL: Record<string, string> = {
  Monday: "Man", Tuesday: "Tir", Wednesday: "Ons", Thursday: "Tor", Friday: "Fre", Saturday: "Lør", Sunday: "Søn",
};

export const STATUS_LABEL: Record<string, string> = {
  idea: "Idé", draft: "Kladde", review: "Til review", ready_buffer: "I buffer", scheduled: "Planlagt",
  publishing: "Udgives", published: "Live", failed: "Fejlet", archived: "Arkiveret",
};
